<section
	[class]="
		'component-input-erro-overlay arrow-' +
		dataCss.arrowDirection +
		' arrow-ref-' +
		dataCss.arrowReference
	"
>
	<div
		class="cieo-arrow"
		[class.bg-primary]="dataCss.arrowColor === 'primary'"
		[class.bg-error]="dataCss.arrowColor === 'danger'"
	></div>
	<main class="cieo-main-container space-y-1">
		@for (error of errorlist; track error) {
			<div class="cieo-row">
				<div class="cieo-label-error" [innerHTML]="error"></div>
			</div>
		}
	</main>
</section>
